import { EuiButtonIcon, EuiFlexGroup, EuiFlexItem } from "@elastic/eui";
import { Button, Divider, Flex, Grid, Group, Input } from "@mantine/core";
import { useForm } from "@mantine/form";
import { modals } from "@mantine/modals";
import { IconSearch } from "@tabler/icons-react";
import {
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MantineReactTable,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { styleTableMantine } from "../../../_base/_const/_constVar";
import BreadCrumb from "../../../_base/component/_layout/_breadcrumb";
import Repository from "../../../_base/helper/HttpHelper";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { MessageResponse } from "../../../model/MessageResponse";
import { TblUserReview } from "../../../model/TblUserReview";
import { api, apiPOS } from "../../../library/axios";

const CollectionWarranty = () => {
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [datas, setDatas] = useState<TblUserReview[]>([]);
  const [total, setTotal] = useState(0);
  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [isLoading, setIsLoading] = useState(false);
  const [selectIds, setSelectIds] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  type SearchCriteria = {
    keySearch?: string;
    ItemId?: string;
    Active?: number;
    Approved?: string;
    Rate?: number;
  };

  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    },
  });

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "id",
        header: "ID",
        size: 50,
      },
      {
        header: "STT",
        accessorKey: "STT",
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 80,
      },
      {
        accessorKey: "customerName",
        header: "Người gửi",
        size: 200,
      },
      {
        accessorKey: "phoneNumber",
        header: "Số điện thoại",
        size: 150,
      },
      {
        accessorKey: "email",
        header: "Email",
        size: 200,
      },
      {
        accessorKey: "address",
        header: "Địa chỉ",
        Cell: ({ row }) => (
          <>
            {row.original.address} - {row.original.communeName ?? ""} -{" "}
            {row.original.districtName ?? ""} -{" "}
            {row.original.provinceName ?? ""}
          </>
        ),
        size: 300,
      },
      {
        accessorKey: "quantity",
        header: "Số lượng",
        size: 100,
      },
      {
        accessorKey: "itemNote",
        header: "Loại sản phẩm",
        size: 200,
        Cell: ({ renderedCellValue }: any) => {
          const getProductTypeStyle = (type: string) => {
            switch (type?.toLowerCase()) {
              case "laptop":
                return {
                  text: "Laptop",
                  color: "#1f77b4",
                  backgroundColor: "#e6f3ff",
                };
              case "printer":
                return {
                  text: "Máy in",
                  color: "#ff7f0e",
                  backgroundColor: "#fff2e6",
                };
              case "server":
                return {
                  text: "Máy chủ",
                  color: "#2ca02c",
                  backgroundColor: "#e6ffe6",
                };
              case "desktop":
                return {
                  text: "Máy tính để bàn",
                  color: "#d62728",
                  backgroundColor: "#ffe6e6",
                };
              case "other":
                return {
                  text: "Khác",
                  color: "#9467bd",
                  backgroundColor: "#f3e6ff",
                };
              default:
                return {
                  text: type,
                  color: "#666666",
                  backgroundColor: "#f5f5f5",
                };
            }
          };

          const style = getProductTypeStyle(renderedCellValue);
          return (
            <span
              style={{
                color: style.color,
                backgroundColor: style.backgroundColor,
                padding: "4px 8px",
                borderRadius: "4px",
                fontWeight: 600,
                fontSize: "12px",
                display: "inline-block",
              }}
            >
              {style.text}
            </span>
          );
        },
      },
      // {
      //   accessorKey: "errorNote",
      //   header: "Lỗi",
      //   size: 200,
      // },
      {
        accessorKey: "attribute4",
        header: "Nội dung yêu cầu của khách hàng",
        size: 280,
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        size: 150,
        Cell: ({ renderedCellValue }) => {
          switch (renderedCellValue) {
            case "TAO_MOI":
              return (
                <span style={{ color: "blue", fontWeight: 600 }}>Tạo mới</span>
              );
            case "DA_TIEP_NHAP":
              return (
                <span style={{ color: "orange", fontWeight: 600 }}>
                  Đã tiếp nhập
                </span>
              );
            case "DA_DONG":
              return (
                <span style={{ color: "red", fontWeight: 600 }}>Đã đóng</span>
              );
            default:
              return <>{renderedCellValue}</>;
          }
        },
      },
      {
        accessorKey: "branchName",
        header: "Chi nhánh",
        size: 200,
      },
      // {
      //   accessorKey: "attribute2",
      //   header: "Thẻ bảo hành tại nơi sử dụng",
      //   size: 200,
      // },
      {
        accessorKey: "createDate",
        header: "Thời gian",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
        size: 150,
      },

      // {
      //   accessorKey: "actions",
      //   header: "Thao tác",
      //   enableColumnActions: false,
      //   enableColumnFilter: false,
      //   enableSorting: false,
      //   size: 70,
      //   Cell: ({ row }) => (
      //     <EuiFlexGroup
      //       responsive={true}
      //       wrap={false}
      //       gutterSize="s"
      //       alignItems="center"
      //     >
      //       <EuiFlexItem grow={false}>
      //         <EuiButtonIcon
      //           iconType="eye"
      //           aria-label="Dashboard"
      //           color="success"
      //           onClick={() => detailData(row.original.id)}
      //         />
      //       </EuiFlexItem>
      //     </EuiFlexGroup>
      //   ),
      // },
    ],
    [datas]
  );

  const fetchDataUserReview = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    const search = form.getValues();
    try {
      let urlSearch = `/api-mdm/api/v1/TblWarrantyReceipt/get-list-for-web?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;
      if (search.keySearch) {
        urlSearch += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      let callapi = await apiPOS.get<MessageResponse<any>>(urlSearch);
      if (callapi && callapi.data.success) {
        setDatas(callapi?.data.data ?? []);
        setRowCount(callapi?.data.totalCount ?? 0);
        setTotal(callapi?.data.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setDatas([]);
        setRowCount(0);
        setIsLoading(false);
      }
      return callapi?.data;
    } catch (error: any) {
      setDatas([]);
      setIsError(true);
      return null;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify(form.getValues())
      );
    }
  };

  const detailData = (id: number) => {
    modals.open({
      title: "Chi tiết đánh giá",
      children: <>{/* <DetailCollectionWarranty id={id} /> */}</>,
      size: "lg",
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchDataUserReview();
    };
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, deleteViewStatus]);
  const table = useMantineReactTable({
    columns,
    data: datas,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableTopToolbar: false,
    enablePagination: true,
    localization: _localization,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    // enableRowSelection: true,
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "userName"],
        right: ["actions"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    getRowId: (row) => row.id,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (250 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  return (
    <>
      <Flex
        gap="md"
        justify={"space-between"}
        align="center"
        direction="row"
        wrap="wrap"
        w={"100%"}
      >
        <BreadCrumb></BreadCrumb>
      </Flex>
      <Divider my="sm" />
      <Grid justify="space-between" align="center" mb={10}>
        <Grid.Col span="auto">
          <Group gap="sm">
            <Input
              placeholder="Nhập tìm kiếm"
              key={form.key("keySearch")}
              type="text"
              leftSection={<IconSearch size={20} color="#15aabf" />}
              onKeyDown={async (e) => {
                if (e.key === "Enter") {
                  await fetchDataUserReview();
                }
              }}
              {...form.getInputProps("keySearch")}
              w={200}
            />
            <Button
              color="blue"
              variant="outline"
              onClick={async () => {
                await fetchDataUserReview();
              }}
            >
              Tìm kiếm
            </Button>
          </Group>
        </Grid.Col>
      </Grid>
      <MantineReactTable table={table} />
    </>
  );
};

export default CollectionWarranty;
